import React from "react";

import { Skeleton } from "@mui/material";
import { Profile } from "iconsax-react";

import convertDateToString from "../../../../libs/convertDateToString";

import { CommentWrapper } from "./styledComment";

const UserCommentComponent = ({ commentInfo }) => {
  const { user_name, user_pic, title, content, datetime, is_verified } = commentInfo;
  return !commentInfo ? (
    <CommentWrapper className="justify-content-center py-3">
      <Skeleton variant="circular" width={60} height={60} className="mx-auto" />
      <div>
        <Skeleton width={50} className="title" />
        <Skeleton width="85%" className="text" />
      </div>
      <Skeleton width={75} height={25} />
    </CommentWrapper>
  ) : (
    is_verified && (
      <CommentWrapper className="py-3">
        <figure className="d-flex flex-sm-column align-items-center mb-1">
          {user_pic ? (
            <img
              src={user_pic}
              alt={user_name}
              width={60}
              height={60}
              className="rounded-circle"
            />
          ) : (
            <Profile
              size={60}
              color="var(--primary-color)"
              className="p-2 border border-primary rounded-circle"
            />
          )}
          <figcaption className="text-center">{user_name}</figcaption>
        </figure>
        <div className="content">
          <p className="title mb-0">{title}</p>
          <p className="text mb-0">{content}</p>
        </div>
        <time className="align-self-center align-self-md-start">
          {convertDateToString("fullNumber", datetime)}
        </time>
      </CommentWrapper>
    )
  );
};

export default UserCommentComponent;
